import { render, staticRenderFns } from "./createStorageLocation.vue?vue&type=template&id=31c2b5e8&scoped=true&"
import script from "./createStorageLocation.vue?vue&type=script&lang=js&"
export * from "./createStorageLocation.vue?vue&type=script&lang=js&"
import style0 from "./createStorageLocation.vue?vue&type=style&index=0&id=31c2b5e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c2b5e8",
  null
  
)

export default component.exports